import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import './plugins/clipboard.js'
import '@/icons' // icon
import '@/styles/index.scss' // global css
import '@/permission' // permission control
import '@/utils/get-common-data'
import '@/utils/instructions'
if(window.sessionStorage.getItem('language')){
  window.sessionStorage.setItem('language',window.sessionStorage.getItem('language'))
}else {
  window.sessionStorage.setItem('language','Chinese')
}
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
zhLocale.el.pagination={
  pagesize: 'article/page',
  total: `{total} items`,
  goto: 'Go to the',
  pageClassifier: 'page'
}




Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
